import type { BridgeConfig } from '@web/api/types'
import { createContext, useContext } from 'react'

export const ConfigContext = createContext<BridgeConfig | null>(null)

export function useConfig(): BridgeConfig | null {
  return useContext(ConfigContext)
}
